import script from "./CompareDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareDialog.vue?vue&type=script&setup=true&lang=js"

import "./CompareDialog.vue?vue&type=style&index=0&id=5e848878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e848878"]])

export default __exports__